var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoldOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.67532 3.65816C8.14355 3.29871 7.79394 2.69018 7.79394 2C7.79394 0.895431 8.68937 0 9.79394 0C10.8985 0 11.7939 0.895431 11.7939 2C11.7939 2.62688 11.5055 3.1864 11.0542 3.5531L15.1895 7.6885L17.077 7.23409C17.6139 7.10482 18.154 7.43531 18.2833 7.97225L19.4536 12.8334C19.5829 13.3703 19.2524 13.9104 18.7154 14.0396L2.40462 17.9665C1.86767 18.0958 1.3276 17.7653 1.19833 17.2283L0.0280086 12.3672C-0.101262 11.8303 0.229223 11.2902 0.766165 11.161L3.55108 10.4905L8.67532 3.65816ZM10.0682 3.98135C9.97853 3.99365 9.88698 4 9.79394 4C9.7529 4 9.71214 3.99876 9.6717 3.99633L5.07652 10.1232L14.0497 7.96291L10.0682 3.98135Z",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoldOut);
export default __webpack_public_path__ + "static/media/Sold-out.659bab18e437d4945f1a900530fce4ce.svg";
export { ForwardRef as ReactComponent };